// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #efefef;
    border-radius: 10px 10px 0px 0px !important;
    height: 60px;
    width: 100%;
  }
  
  .leftInnerContainer {
    flex: 0.5 1;
    display: flex;
    align-items: center;
    margin-left: 5%;
    color: black;
  }
  
  .rightInnerContainer {
    display: flex;
    flex: 0.5 1;
    justify-content: flex-end;
    margin-right: 5%;
    color: black;
  }
  
  .appLogo2{
    width:30px;
    height:30px;
    background-color: transparent;
    border-radius: 100px;
    margin:5px;
  }`, "",{"version":3,"sources":["webpack://./src/pages/Chatbot_v2/components/InfoBar/InfoBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,2CAA2C;IAC3C,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAS;IACT,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,WAAS;IACT,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,oBAAoB;IACpB,UAAU;EACZ","sourcesContent":[".infoBar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #efefef;\n    border-radius: 10px 10px 0px 0px !important;\n    height: 60px;\n    width: 100%;\n  }\n  \n  .leftInnerContainer {\n    flex: 0.5;\n    display: flex;\n    align-items: center;\n    margin-left: 5%;\n    color: black;\n  }\n  \n  .rightInnerContainer {\n    display: flex;\n    flex: 0.5;\n    justify-content: flex-end;\n    margin-right: 5%;\n    color: black;\n  }\n  \n  .appLogo2{\n    width:30px;\n    height:30px;\n    background-color: transparent;\n    border-radius: 100px;\n    margin:5px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
